import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, effect, EventEmitter, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { PrimeNgModule } from '../shared/prime-ng.module';
import { RouterModule } from '@angular/router';
import { ProjectService } from '../services/project.service';
import { APIUrl } from '../constant/api-call';
import { ClientService } from '../services/client.service';
import { firstValueFrom } from 'rxjs';
import { AbstractControl } from '@angular/forms';
import _ from 'underscore';
import { Accordion, AccordionPanel, AccordionHeader, AccordionContent } from 'primeng/accordion';

@Component({
  selector: 'app-form-configuration',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PrimeNgModule, RouterModule, Accordion, AccordionPanel, AccordionHeader, AccordionContent],
  templateUrl: './form-configuration.component.html',
  styleUrl: './form-configuration.component.css',
})

export class FormconfigurationComponent {
  @Output() formConfigSaved = new EventEmitter<boolean>();
  public layoutTypeOptions = [
    { label: 'Simple', value: 'Simple' },
    { label: 'Matrix', value: 'Matrix' }
  ];
  public dataTypeOptions = [
    { label: 'Number', value: 'Number' },
    { label: 'Currency', value: 'Currency' },
    { label: 'Text', value: 'Text' },
    { label: 'Year', value: 'Year' },
    { label: 'Month', value: 'Month' },
    { label: 'Date', value: 'Date' },
    { label: 'Dropdown', value: 'Dropdown' }
  ];
  public rowCalcOptions = [
    { label: 'None', value: null },
    { label: 'Row Summable', value: 'sum' },
    { label: 'Row Multiply', value: 'multiply' }
  ];
  public configForm!: FormGroup;
  public activeTabIndex = 0;
  public selectedForm: any = null;
  public formName: string = '';
  public isActive: boolean = true;
  public showDeleteDialog: boolean = false;
  public successMessage: string = '';
  public errorMessage: string = '';
  public masterTypes: any[] = [];
  public subMasterList: any[] = [];
  public formList: any[] = [];
  public formConfig: any = null;
  public autoSelectEnabled = true;
  public masterTypeSelections: { [key: number]: number[] } = {};
  public rowMasterSelections: { [key: number]: { [key: number]: number[] } } = {};
  public rowSubMasterSelections: { [key: number]: { [key: number]: number[] } } = {};
  public rowMapSelections: { [key: number]: { [key: number]: { [key: string]: number } } } = {};
  public originalRowIdMap: { [key: string]: number } = {};
  public originalFieldIdMap: { [key: string]: number } = {};
  private successTimeout: any;
  private errorTimeout: any;
  private isUpdatingFormName: boolean = false;
  public showInfoDialog = false;
  public isDialogClosing = false;
  public formSectionList: any;
  public section1: any;
  public section2: any;
  public operatorList = [
    { label: 'Addition (+)', value: '+' },
    { label: 'Subtraction (-)', value: '-' },
    // { label: 'Division (/)', value: '/' },
    // { label: 'Multiplication (*)', value: '*' }
  ]
  public operatorValue1: any;
  public operatorValue2: any;
  public masterList: any;
  public masterFieldValue: any
  public masterOperatorValue: any
  public showReportConfig: any
  public rowOperatorSelections: { [key: number]: { [key: number]: { [key: number]: string | null } } } = {};
  public cutome_formula_title: any
  public formulasForm!: FormArray;
  public tempFormulaData: any
  public accordionVal = "1";
  public summaryTitle = '';
  public summaryTypeList = [
    { label: 'Sumn of Signed Row Above', value: 'signed' },
    { label: 'Sum of All Rows (Default)', value: null },
    { label: 'No Summary Row', value: 'none' },
  ]

  constructor(
    private fb: FormBuilder,
    public projectService: ProjectService,
    private clientService: ClientService,
    public cdr: ChangeDetectorRef
  ) {
    this.initializeForm();
    effect(() => {
      const forms = this.projectService.getFormList();
      this.masterList = this.projectService.getMasterList();
      this.formList = forms || [];
      if (this.autoSelectEnabled && forms?.length === 1 && !this.selectedForm) {
        this.selectedForm = forms[0];
        this.onFormChange();
      }
    });
  }

  ngOnInit() {
    this.loadMasterData();
    this.loadFormList();
  }

  initializeForm() {
    this.formulasForm = this.fb.array([]);
    this.configForm = this.fb.group({
      project_id: [this.projectService.selectedProject()?.project_id],
      form_id: [null],
      form_name: ['', Validators.required],
      is_active: [true],
      is_delete: [false],
      sections: this.fb.array([])
    });
    this.configForm.get('form_name')?.valueChanges.subscribe(value => {
      if (!this.isUpdatingFormName) {
        this.formName = value || '';
      }
    });
    this.configForm.get('is_active')?.valueChanges.subscribe(value => {
      this.isActive = value;
    });
    this.sections.valueChanges.subscribe(() => {
      this.configForm.updateValueAndValidity();
    });
  }

  updateFormName(value: string) {
    this.formName = value;
    this.isUpdatingFormName = true;
    this.configForm.patchValue({ form_name: value }, { emitEvent: false });
    this.isUpdatingFormName = false;
  }

  async loadMasterData() {
    await this.projectService?.getMasterData();
    setTimeout(() => {
      this.masterTypes = this.projectService?.getMasterTypes();
      this.subMasterList = this.projectService?.getSubMasterList();
    }, 500);
  }

  loadFormList() {
    const projectId = this.projectService.selectedProject()?.project_id;
    if (projectId) {
      this.projectService?.getFormsProjectWise(projectId);
    }
  }

  async onFormChange() {
    const formId = this.selectedForm?.form_id || this.selectedForm;
    if (!formId) {
      this.resetForm();
      return;
    }
    this.projectService.loading.set(true);
    try {
      this.formConfig = await firstValueFrom(
        this.projectService.getFormDetails(formId)
      );
      if (this.formConfig) {
        this.editForm(this.formConfig);
        this.activeTabIndex = 0;
      } else {
        this.resetForm();
        if (this.selectedForm?.form_name) {
          this.updateFormName(this.selectedForm.form_name);
        }
      }
    } catch (error) {
      console.error('onFormChange error:', error);
      this.resetForm();
      this.showError('Failed to load form details');
    } finally {
      this.projectService.loading.set(false);
    }
  }

  get sections(): FormArray {
    return this.configForm.get('sections') as FormArray;
  }

  setActiveTab(index: number) {
    this.activeTabIndex = index;
  }

  addSection() {
    const newSection = this.createSection();
    this.sections.push(newSection);
    const sectionIndex = this.sections.length - 1;
    this.masterTypeSelections[sectionIndex] = [];
    this.rowMasterSelections[sectionIndex] = {};
    this.rowSubMasterSelections[sectionIndex] = {};
    this.rowMapSelections[sectionIndex] = {};
    this.rowOperatorSelections[sectionIndex] = {};
    this.activeTabIndex = sectionIndex;
  }

  removeSection(index: number, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    const wasActive = this.activeTabIndex === index;
    this.sections.removeAt(index);
    this.reindexSelectionsAfterSectionRemoval(index);
    if (wasActive) {
      this.activeTabIndex = Math.min(index, this.sections.length - 1);
    } else if (this.activeTabIndex > index) {
      this.activeTabIndex--;
    }
  }

  private reindexSelectionsAfterSectionRemoval(removedIndex: number) {
    const newMasterTypeSelections: { [key: number]: number[] } = {};
    const newRowMasterSelections: { [key: number]: { [key: number]: number[] } } = {};
    const newRowSubMasterSelections: { [key: number]: { [key: number]: number[] } } = {};
    const newRowMapSelections: { [key: number]: { [key: number]: { [key: string]: number } } } = {};
    const newRowOperatorSelections: { [key: number]: { [key: number]: { [key: number]: string | null } } } = {};
    this.sections.controls.forEach((_, newIndex) => {
      let originalIndex = newIndex;
      if (newIndex >= removedIndex) {
        originalIndex = newIndex + 1;
      }
      if (this.masterTypeSelections[originalIndex] !== undefined) {
        newMasterTypeSelections[newIndex] = [...this.masterTypeSelections[originalIndex]];
      }
      if (this.rowMasterSelections[originalIndex] !== undefined) {
        newRowMasterSelections[newIndex] = { ...this.rowMasterSelections[originalIndex] };
      }
      if (this.rowSubMasterSelections[originalIndex] !== undefined) {
        newRowSubMasterSelections[newIndex] = { ...this.rowSubMasterSelections[originalIndex] };
      }
      if (this.rowMapSelections[originalIndex] !== undefined) {
        newRowMapSelections[newIndex] = { ...this.rowMapSelections[originalIndex] };
      }
      if (this.rowOperatorSelections[originalIndex] !== undefined) {
        newRowOperatorSelections[newIndex] = { ...this.rowOperatorSelections[originalIndex] };
      }
    });
    this.masterTypeSelections = newMasterTypeSelections;
    this.rowMasterSelections = newRowMasterSelections;
    this.rowSubMasterSelections = newRowSubMasterSelections;
    this.rowMapSelections = newRowMapSelections;
    this.rowOperatorSelections = newRowOperatorSelections;
  }

  addField(sectionIndex: number) {
    this.getSectionFields(sectionIndex).push(this.createField());
  }

  removeField(sectionIndex: number, fieldIndex: number) {
    this.getSectionFields(sectionIndex).removeAt(fieldIndex);
  }

  removeRow(sectionIndex: number, rowIndex: number) {
    const section = this.sections.at(sectionIndex);
    const rows = section.get('matrix_rows') as FormArray;
    const rowToRemove = rows.at(rowIndex);
    const removedMasterTypeId = rowToRemove.get('master_type_id')?.value;
    rows.removeAt(rowIndex);
    if (removedMasterTypeId) {
      const remainingRowsWithSameType = rows.controls.some((row: any) => {
        return row.get('master_type_id')?.value === removedMasterTypeId;
      });
      if (!remainingRowsWithSameType) {
        const currentSelections = [...(this.masterTypeSelections[sectionIndex] || [])];
        const updatedSelections = currentSelections?.filter(id => id !== removedMasterTypeId);
        this.masterTypeSelections[sectionIndex] = updatedSelections;
        section.get('master_type_id')?.setValue(updatedSelections);
        if (rows.length > 0) {
          this.onMasterTypeChange(sectionIndex);
        }
      }
    }
    this.rebuildRowSelections(sectionIndex);
  }

  private rebuildRowSelections(sectionIndex: number) {
    const rows = this.getSectionRows(sectionIndex);
    const newMasterSelections: { [key: number]: number[] } = {};
    const newSubMasterSelections: { [key: number]: number[] } = {};
    const newRowMapSelections: { [key: number]: { [key: string]: number } } = {};
    const newOperatorSelections: { [key: number]: { [key: number]: string | null } } = {};
    rows.controls.forEach((row: any, newIndex: number) => {
      newMasterSelections[newIndex] = row.get('master_value_ids')?.value || [];
      newSubMasterSelections[newIndex] = row.get('sub_master_value_ids')?.value || [];
      newRowMapSelections[newIndex] = row.get('rowMapData')?.value || {};
      newOperatorSelections[newIndex] = row.get('master_operator_map')?.value || {};
    });
    this.rowMasterSelections[sectionIndex] = newMasterSelections;
    this.rowSubMasterSelections[sectionIndex] = newSubMasterSelections;
    this.rowMapSelections[sectionIndex] = newRowMapSelections;
    this.rowOperatorSelections[sectionIndex] = newOperatorSelections;
  }

  createSection(section?: any): FormGroup {
    const masterTypeValue = section?.master_type_id
      ? (typeof section?.master_type_id === 'string'
        ? section?.master_type_id.split(',').map((x: string) => +x)
        : section?.master_type_id)
      : [];
    const sectionGroup = this.fb.group({
      section_id: [section?.section_id || null],
      section_name: [section?.section_name || '', Validators.required],
      layout_type: [section?.layout_type || 'Simple'],
      master_type_id: [masterTypeValue || []],
      row_calculation: [section?.row_calculation || null],
      fields: this.fb.array([]),
      matrix_rows: this.fb.array([]),
      summary_row_label: [section?.summary_row_label || null],
      summary_row_type: [section?.summary_row_type || null],
    });
    const fieldsArray = sectionGroup.get('fields') as FormArray;
    if (section?.fields && section.fields.length > 0) {
      section.fields.forEach((f: any) => {
        fieldsArray.push(this.createField(f));
      });
    }
    sectionGroup.get('layout_type')?.valueChanges.subscribe(layoutType => {
      const isMatrix = layoutType === 'Matrix';
      const sectionNameCtrl = sectionGroup.get('section_name');
      const masterTypeCtrl = sectionGroup.get('master_type_id');
      const matrixRows = sectionGroup.get('matrix_rows') as FormArray;
      if (isMatrix) {
        sectionNameCtrl?.setValidators([Validators.required]);
        masterTypeCtrl?.setValidators([Validators.required]);
      } else {
        sectionNameCtrl?.clearValidators();
        masterTypeCtrl?.clearValidators();
        matrixRows.clear();
      }
      sectionNameCtrl?.updateValueAndValidity();
      masterTypeCtrl?.updateValueAndValidity();
    });

    return sectionGroup;
  }

  createField(field?: any): FormGroup {
    const fieldLabel = field?.field_label ?? '';
    const fieldKey = field?.field_key ?? this.generateKey(fieldLabel);
    const fieldGroup = this.fb.group({
      field_id: [field?.field_id ?? null],
      field_label: [fieldLabel, Validators.required],
      field_key: [fieldKey, Validators.required],
      field_type: [field?.field_type ?? 'Text', Validators.required],
      master_value_id: [field?.master_value_id ?? null],
      is_required: [field?.is_required ?? false],
      is_column_summable: [field?.is_column_summable ?? false],
      field_index_id: [field?.field_index_id, Validators.required]
    });

    const fieldLabelCtrl = fieldGroup.get('field_label');
    const fieldKeyCtrl = fieldGroup.get('field_key');
    if (fieldLabelCtrl) {
      fieldLabelCtrl.valueChanges.subscribe((label: string) => {
        const autoGeneratedKey = this.generateKey(label);
        fieldKeyCtrl?.setValue(autoGeneratedKey, { emitEvent: false });
      });
    }
    if (field?.field_type === 'Dropdown') {
      fieldGroup.get('master_value_id')?.setValidators([Validators.required]);
    }
    return fieldGroup;
  }

  createMatrixRow(masterTypeId: number, rowData?: any): FormGroup {
    const type = this.masterTypes.find(t => t.master_type_id === masterTypeId);
    const masterValueIds = rowData?.master_value_ids ? [...new Set(rowData.master_value_ids)] : [];
    const subMasterValueIds = rowData?.sub_master_value_ids ? [...new Set(rowData.sub_master_value_ids)] : [];
    const rowMapData = rowData?.rowMapData || {};
    const masterOperatorMap = rowData?.master_operator_map || {};

    return this.fb.group({
      section_matrix_row_id: [rowData?.section_matrix_row_id || null],
      rowMapData: [rowMapData],
      master_type_id: [masterTypeId],
      label: [type?.master_type_name || ''],
      master_value_ids: [masterValueIds, Validators.required],
      sub_master_value_ids: [subMasterValueIds],
      master_operator_map: [masterOperatorMap]
    });
  }

  getSectionName(section: AbstractControl, index: number): string {
    const sectionName = section.get('section_name')?.value;
    return sectionName || 'Section ' + (index + 1);
  }

  getRowMasterValues(sectionIndex: number, rowIndex: number): number[] {
    return this.rowMasterSelections[sectionIndex]?.[rowIndex] || [];
  }

  setRowMasterValues(sectionIndex: number, rowIndex: number, values: number[]) {
    if (!this.rowMasterSelections[sectionIndex]) {
      this.rowMasterSelections[sectionIndex] = {};
    }
    this.rowMasterSelections[sectionIndex][rowIndex] = values || [];
    this.syncRowOperatorSelections(sectionIndex, rowIndex, values || []);
    this.onMasterSelectionChange(sectionIndex, rowIndex);
  }

  private syncRowOperatorSelections(sectionIndex: number, rowIndex: number, masterValueIds: number[]) {
    if (!this.rowOperatorSelections[sectionIndex]) {
      this.rowOperatorSelections[sectionIndex] = {};
    }
    const existing = this.rowOperatorSelections[sectionIndex][rowIndex] || {};
    const updated: { [key: number]: string | null } = {};
    masterValueIds.forEach(id => {
      updated[id] = existing[id] !== undefined ? existing[id] : '+';
    });
    this.rowOperatorSelections[sectionIndex][rowIndex] = updated;
    this.syncOperatorFormControl(sectionIndex, rowIndex);
  }

  getRowOperatorValue(sectionIndex: number, rowIndex: number, masterValueId: number): string | null {
    return this.rowOperatorSelections[sectionIndex]?.[rowIndex]?.[masterValueId] ?? null;
  }

  setRowOperatorValue(sectionIndex: number, rowIndex: number, masterValueId: number, value: string | null) {
    if (!this.rowOperatorSelections[sectionIndex]) {
      this.rowOperatorSelections[sectionIndex] = {};
    }
    if (!this.rowOperatorSelections[sectionIndex][rowIndex]) {
      this.rowOperatorSelections[sectionIndex][rowIndex] = {};
    }
    this.rowOperatorSelections[sectionIndex][rowIndex][masterValueId] = value;
    this.syncOperatorFormControl(sectionIndex, rowIndex);
  }

  private syncOperatorFormControl(sectionIndex: number, rowIndex: number) {
    const row = this.getSectionRows(sectionIndex)?.at(rowIndex);
    if (!row) return;
    row.get('master_operator_map')?.setValue(
      this.rowOperatorSelections[sectionIndex][rowIndex] || {},
      { emitEvent: false }
    );
  }

  getMasterValueName(masterTypeId: number, masterValueId: number): string {
    const master = this.getMastersByType(masterTypeId)?.find((m: any) => m.master_value_id === masterValueId);
    return master?.master_value_name || '';
  }

  getRowSubMasterValues(sectionIndex: number, rowIndex: number): number[] {
    return this.rowSubMasterSelections[sectionIndex]?.[rowIndex] || [];
  }

  setRowSubMasterValues(sectionIndex: number, rowIndex: number, values: number[]) {
    if (!this.rowSubMasterSelections[sectionIndex]) {
      this.rowSubMasterSelections[sectionIndex] = {};
    }
    this.rowSubMasterSelections[sectionIndex][rowIndex] = values || [];
    this.onSubMasterChange(sectionIndex, rowIndex);
  }

  getSectionFields(sectionIndex: number): FormArray {
    return this.sections.at(sectionIndex).get('fields') as FormArray;
  }

  getSectionRows(sectionIndex: number): FormArray {
    const section = this.sections.at(sectionIndex);
    return section.get('matrix_rows') as FormArray;
  }

  onFieldTypeChange(sectionIndex: number, fieldIndex: number) {
    const field = this.getSectionFields(sectionIndex).at(fieldIndex);
    const fieldType = field?.get('field_type')?.value;
    const masterCtrl = field?.get('master_value_id');
    if (fieldType === 'Dropdown') {
      masterCtrl?.setValidators([Validators.required]);
    } else {
      masterCtrl?.clearValidators();
      masterCtrl?.reset(null);
    }
    masterCtrl?.updateValueAndValidity();
  }

  onFieldLabelBlur(field: AbstractControl) {
    const label = field.get('field_label')?.value;
    const fieldKeyCtrl = field.get('field_key');

    if (label) {
      const generatedKey = this.generateKey(label);
      fieldKeyCtrl?.setValue(generatedKey, { emitEvent: false });
    }
  }

  onLayoutChange(sectionIndex: number) {
    const section = this.sections.at(sectionIndex);
    const layoutType = section.get('layout_type')?.value;
    if (layoutType !== 'Matrix') {
      const rows = section.get('matrix_rows') as FormArray;
      rows.clear();
      delete this.rowMasterSelections[sectionIndex];
      delete this.rowSubMasterSelections[sectionIndex];
      delete this.rowMapSelections[sectionIndex];
      delete this.rowOperatorSelections[sectionIndex];
    } else {
      this.initializeRowSelections(sectionIndex);
    }
  }

  onMasterTypeChange(sectionIndex: number) {
    const section = this.sections.at(sectionIndex);
    if (!section) return;
    const selectedTypes = this.masterTypeSelections[sectionIndex] || [];
    section.get('master_type_id')?.setValue(selectedTypes);
    const rows = section.get('matrix_rows') as FormArray;
    const existingRowsMap = new Map<number, FormGroup>();
    if (rows) {
      rows.controls.forEach((row: any) => {
        const typeId = row.get('master_type_id')?.value;
        if (typeId) {
          existingRowsMap.set(typeId, row);
        }
      });
    }
    const newRows: FormGroup[] = [];
    selectedTypes.forEach(typeId => {
      if (existingRowsMap.has(typeId)) {
        newRows.push(existingRowsMap.get(typeId)!);
      } else {
        const newRow = this.createMatrixRow(typeId);
        newRows.push(newRow);
      }
    });
    if (rows) {
      rows.clear();
      newRows.forEach(r => rows.push(r));
    }
    this.initializeRowSelections(sectionIndex);
  }

  initializeRowSelections(sectionIndex: number) {
    const rows = this.getSectionRows(sectionIndex);
    this.rowMasterSelections[sectionIndex] = {};
    this.rowSubMasterSelections[sectionIndex] = {};
    this.rowMapSelections[sectionIndex] = {};
    this.rowOperatorSelections[sectionIndex] = {};

    rows.controls.forEach((row: any, rowIndex: number) => {
      this.rowMasterSelections[sectionIndex][rowIndex] = row.get('master_value_ids')?.value || [];
      this.rowSubMasterSelections[sectionIndex][rowIndex] = row.get('sub_master_value_ids')?.value || [];
      this.rowMapSelections[sectionIndex][rowIndex] = row.get('rowMapData')?.value || {};
      this.rowOperatorSelections[sectionIndex][rowIndex] = row.get('master_operator_map')?.value || {};
    });
  }

  onMasterSelectionChange(sectionIndex: number, rowIndex: number) {
    const row = this.getSectionRows(sectionIndex).at(rowIndex);
    if (!row) return;
    const selectedIds = this.rowMasterSelections[sectionIndex]?.[rowIndex] || [];
    const unique = [...new Set(selectedIds)];
    this.rowMasterSelections[sectionIndex][rowIndex] = unique;
    row.get('master_value_ids')?.setValue(unique, { emitEvent: false });
    this.updateSubMasterValidation(sectionIndex, rowIndex);
  }

  onSubMasterChange(sectionIndex: number, rowIndex: number) {
    const row = this.getSectionRows(sectionIndex).at(rowIndex);
    if (!row) return;
    const selectedIds = this.rowSubMasterSelections[sectionIndex]?.[rowIndex] || [];
    const unique = [...new Set(selectedIds)];
    this.rowSubMasterSelections[sectionIndex][rowIndex] = unique;
    row.get('sub_master_value_ids')?.setValue(unique, { emitEvent: false });
  }

  private updateSubMasterValidation(sectionIndex: number, rowIndex: number) {
    const row = this.getSectionRows(sectionIndex).at(rowIndex);
    if (!row) return;
    const masterIds: number[] = row.get('master_value_ids')?.value || [];
    const hasAnySubMaster = masterIds.some(id =>
      this.getSubMastersByMasterId(id)?.length > 0
    );
    const subMasterCtrl = row.get('sub_master_value_ids');
    if (subMasterCtrl) {
      if (hasAnySubMaster) {
        // subMasterCtrl.setValidators([Validators.required]);
      } else {
        subMasterCtrl.clearValidators();
        subMasterCtrl.setValue([], { emitEvent: false });
      }
      subMasterCtrl.updateValueAndValidity();
    }
  }

  getMasterTypeName(id: number): string {
    if (!id) return '';
    const master = this.masterTypes.find(t => t.master_type_id === id);
    return master?.master_type_name || '';
  }

  getMastersByType(masterTypeId: number): any[] {
    if (!masterTypeId) return [];
    const list = this.projectService.getActiveMasterList()
      ?.filter((m: any) => m.master_type_id === masterTypeId && m.is_active);
    return Array.from(new Map(list.map(item => [item.master_value_id, item])).values());
  }

  getSubMastersWithLabel(masterIds: number[] = []): any[] {
    if (!Array.isArray(masterIds) || masterIds.length === 0) return [];
    const map = new Map();
    masterIds.forEach(id => {
      const master = this.projectService.getActiveMasterList().find((m: any) => m.master_value_id === id);
      if (master?.sub_master_values_details) {
        master.sub_master_values_details
          ?.filter((sm: any) => sm.is_active)
          ?.forEach((sm: any) => {
            if (!map.has(sm.sub_master_value_id)) {
              map.set(sm.sub_master_value_id, {
                ...sm,
                display_name: `${sm.sub_master_value_name} (${master.master_value_name})`
              });
            }
          });
      }
    });
    return Array.from(map.values());
  }

  private getSubMastersByMasterId(masterId: number): any[] {
    const master = this.projectService.getActiveMasterList()
      .find((m: any) => m.master_value_id === masterId);
    return master?.sub_master_values_details?.filter((sm: any) => sm.is_active) || [];
  }

  trackByRow(index: number, row: any): any {
    const rowId = row.get('section_matrix_row_id')?.value;
    return rowId !== null ? rowId : index;
  }

  trackByField(index: number, field: any): any {
    const fieldId = field.get('field_id')?.value;
    return fieldId !== null ? fieldId : index;
  }

  trackBySection(index: number, section: any): any {
    const sectionId = section.get('section_id')?.value;
    return sectionId !== null ? sectionId : index;
  }

  canSubmit(): boolean {
    const formNameValid = this.formName && this.formName.trim().length > 0;
    if (this.sections.controls.length === 0 || !formNameValid || !this.configForm.valid) {
      return false;
    }
    const sectionsArray = this.sections;
    const allMatrixRowsValid = sectionsArray.controls.every(section => {
      const layoutType = section.get('layout_type')?.value;
      const masterType = section.get('master_type_id')?.value;
      const fields = section.get('fields')?.value;
      const rows = section.get('matrix_rows') as FormArray;
      const arr = _.pluck(fields, 'field_index_id');
      if (arr.length > 0) {
        const setArray = new Set(arr);
        if (setArray.size !== arr.length) {
          return false;
        }
      }
      if (((layoutType === 'Simple') || (layoutType === 'Matrix')) && fields.length === 0) {
        return false;
      }
      if (layoutType === 'Matrix' && masterType?.length > 0) {
        return rows && rows.length > 0 && rows.valid;
      }
      return true;
    });
    return allMatrixRowsValid;
  }

  editForm(data: any) {
    this.sections.clear();
    this.formulasForm.clear();
    this.masterTypeSelections = {};
    this.rowMasterSelections = {};
    this.rowSubMasterSelections = {};
    this.rowMapSelections = {};
    this.rowOperatorSelections = {};
    this.originalRowIdMap = {};
    this.originalFieldIdMap = {};
    this.configForm.patchValue({
      project_id: data.project_id,
      form_id: data.form_id,
      form_name: data.form_name,
      is_active: data.is_active,
      is_delete: data.is_delete
    });
    this.formName = data.form_name;
    this.isActive = data.is_active;
    this.selectedForm = data.form_id;
    if (data.sections && data.sections.length > 0) {
      data.sections.forEach((section: any, sectionIndex: number) => {
        let masterTypeIds: number[] = [];
        if (section.master_type_id) {
          masterTypeIds = typeof section.master_type_id === 'string'
            ? section.master_type_id.split(',').map((x: string) => +x)?.filter((x: number) => !isNaN(x))
            : section.master_type_id;
        }
        this.masterTypeSelections[sectionIndex] = masterTypeIds;
        const sectionGroup = this.createSection(section);
        this.sections.push(sectionGroup);
        if (section.fields && section.fields.length > 0) {
          section.fields.forEach((field: any) => {
            const fieldKey = field.field_key || this.generateKey(field.field_label);
            const uniqueFieldKey = `${sectionIndex}_${fieldKey}`;
            this.originalFieldIdMap[uniqueFieldKey] = field.field_id;
          });
        }
        if (section.layout_type === 'Matrix' && section.matrix_rows?.length) {
          if (!this.rowMasterSelections[sectionIndex]) {
            this.rowMasterSelections[sectionIndex] = {};
          }
          if (!this.rowSubMasterSelections[sectionIndex]) {
            this.rowSubMasterSelections[sectionIndex] = {};
          }
          if (!this.rowMapSelections[sectionIndex]) {
            this.rowMapSelections[sectionIndex] = {};
          }
          if (!this.rowOperatorSelections[sectionIndex]) {
            this.rowOperatorSelections[sectionIndex] = {};
          }

          const rowsMap = new Map<string, {
            masterTypeId: number,
            masterValueId: number,
            subMasterValueId: number | null,
            section_matrix_row_id: number,
            operator_value: string
          }>();

          section.matrix_rows.forEach((row: any) => {
            const master = this.projectService.getActiveMasterList()
              .find((m: any) => m.master_value_id === row.master_value_id);
            const masterTypeId = master?.master_type_id;
            if (masterTypeId) {
              const subMasterId = row.sub_master_value_id || null;
              const mapKey = `${masterTypeId}_${row.master_value_id}_${subMasterId}`;
              const uniqueKey = `${sectionIndex}_${masterTypeId}_${row.master_value_id}_${subMasterId}`;
              this.originalRowIdMap[uniqueKey] = row.section_matrix_row_id;
              rowsMap.set(mapKey, {
                masterTypeId,
                masterValueId: row.master_value_id,
                subMasterValueId: subMasterId,
                section_matrix_row_id: row.section_matrix_row_id,
                operator_value: row?.operator_value || '+'
              });
            }
          });
          const rowsByMasterType = new Map<number, {
            masterIds: number[],
            subMasterIds: number[],
            rowMapData: { [key: string]: number },
            operatorMap: { [key: number]: string | null }
          }>();
          rowsMap.forEach((rowData) => {
            const masterTypeId = rowData.masterTypeId;
            if (!rowsByMasterType.has(masterTypeId)) {
              rowsByMasterType.set(masterTypeId, {
                masterIds: [],
                subMasterIds: [],
                rowMapData: {},
                operatorMap: {}
              });
            }
            const typeData = rowsByMasterType.get(masterTypeId)!;
            if (!typeData.masterIds.includes(rowData.masterValueId)) {
              typeData.masterIds.push(rowData.masterValueId);
            }
            if (rowData.subMasterValueId !== null && !typeData.subMasterIds.includes(rowData.subMasterValueId)) {
              typeData.subMasterIds.push(rowData.subMasterValueId);
            }
            const key = rowData.subMasterValueId !== null
              ? `${rowData.masterValueId}_${rowData.subMasterValueId}`
              : `${rowData.masterValueId}_null`;
            typeData.rowMapData[key] = rowData.section_matrix_row_id;
            typeData.operatorMap[rowData.masterValueId] = rowData.operator_value ?? '+';
          });
          const matrixRowsArray = sectionGroup.get('matrix_rows') as FormArray;
          matrixRowsArray.clear();
          rowsByMasterType.forEach((rowData, masterTypeId) => {
            const newRow = this.createMatrixRow(masterTypeId, {
              master_value_ids: rowData.masterIds,
              sub_master_value_ids: rowData.subMasterIds,
              rowMapData: rowData.rowMapData,
              master_operator_map: rowData.operatorMap
            });
            matrixRowsArray.push(newRow);
          });
          matrixRowsArray.controls.forEach((row: any, rowIndex: number) => {
            this.rowMasterSelections[sectionIndex][rowIndex] = row.get('master_value_ids')?.value || [];
            this.rowSubMasterSelections[sectionIndex][rowIndex] = row.get('sub_master_value_ids')?.value || [];
            this.rowMapSelections[sectionIndex][rowIndex] = row.get('rowMapData')?.value || {};
            this.rowOperatorSelections[sectionIndex][rowIndex] = row.get('master_operator_map')?.value || {};
            this.updateSubMasterValidation(sectionIndex, rowIndex);
          });
        }
        const fieldsArray = sectionGroup.get('fields') as FormArray;
        if (section.fields && section.fields.length > 0) {
          fieldsArray.clear();
          section.fields.forEach((field: any) => {
            fieldsArray.push(this.createField(field));
          });
        }
      });
    }
    // for formula logic
    this.showReportConfig = false;
    if (data.formula && data.formula.length > 0) {
      this.showReportConfig = true;
      data.formula.forEach((f: any) => {
        this.formulasForm.push(this.createSectionFormula(f));
      });
    }
  }

  submitConfig() {
    if (!this.formName || this.formName.trim() === '') {
      this.showError('Please enter a form name');
      return;
    }
    this.configForm.patchValue({ form_name: this.formName });
    if (!this.configForm.valid) {
      this.showError('Please fill all required fields');
      return;
    }
    this.autoSelectEnabled = false;
    this.projectService.loading.set(true);
    const formId = this.selectedForm?.form_id || this.selectedForm;
    this.configForm.patchValue({
      form_id: formId,
      form_name: this.formName,
      is_active: this.isActive,
    });
    const sectionsArray = this.sections;
    sectionsArray.controls.forEach((section, idx) => {
      section.get('master_type_id')?.setValue(this.masterTypeSelections[idx] || []);
      const rows = section.get('matrix_rows') as FormArray;
      rows.controls.forEach((row, rowIdx) => {
        row.get('master_value_ids')?.setValue(this.rowMasterSelections[idx]?.[rowIdx] || []);
        row.get('sub_master_value_ids')?.setValue(this.rowSubMasterSelections[idx]?.[rowIdx] || []);
        row.get('rowMapData')?.setValue(this.rowMapSelections[idx]?.[rowIdx] || {});
      });
    });
    const payload = this.preparePayload();
    this.clientService.postAPI(APIUrl.FORM_CONFIG_UPSERT, payload).subscribe({
      next: (res: any) => {
        if (res && res.code === 'CSR_MS_OK_200') {
          this.formConfigSaved.emit(true);
          this.showSuccess(res.message);
          this.resetForm();
          this.loadFormList();
          this.showDeleteDialog = false;
        } else {
          this.showError(res.message);
        }
        setTimeout(() => {
          this.projectService.loading.set(false);
        }, 2000);
      },
      error: (error) => {
        this.showError(error.error?.message);
        setTimeout(() => {
          this.projectService.loading.set(false);
        }, 2000);
      }
    });
  }

  onDeleteForm() {
    if (!this.selectedForm) {
      this.showError('No form selected to delete');
      return;
    }
    this.showDeleteDialog = true;
  }

  confirmDelete() {
    this.autoSelectEnabled = false;
    this.projectService.loading.set(true);
    const formId = this.selectedForm?.form_id || this.selectedForm;
    this.configForm.patchValue({
      form_id: formId,
      is_delete: true
    });
    const payload = this.preparePayload();
    this.clientService.postAPI(APIUrl.FORM_CONFIG_UPSERT, payload).subscribe({
      next: (res: any) => {
        if (res && res.code === 'CSR_MS_OK_200') {
          this.formConfigSaved.emit(true);
          this.showSuccess('Form configuration deleted successfully');
          this.resetForm();
          this.loadFormList();
          this.showDeleteDialog = false;
        } else {
          this.showError(res.message);
        }
        setTimeout(() => {
          this.projectService.loading.set(false);
        }, 2000);
      },
      error: (error) => {
        this.showError(error.error?.message);
        setTimeout(() => {
          this.projectService.loading.set(false);
        }, 2000);
      }
    });
  }

  private preparePayload(): any {
    let payload = JSON.parse(JSON.stringify(this.configForm.value));
    payload.sections.forEach((section: any, sectionIndex: number) => {
      if (Array.isArray(section.master_type_id) && section.master_type_id.length > 0) {
        section.master_type_id = section.master_type_id.join(',');
      } else {
        section.master_type_id = null;
      }
      if (section.fields && section.fields.length > 0) {
        section.fields.forEach((field: any) => {
          if (!field.field_id) {
            const fieldKey = field.field_key || this.generateKey(field.field_label);
            const uniqueFieldKey = `${sectionIndex}_${fieldKey}`;
            const cachedFieldId = this.originalFieldIdMap[uniqueFieldKey];
            if (cachedFieldId) {
              field.field_id = cachedFieldId;
            }
          }
        });
      }
      if (section.matrix_rows && section.matrix_rows.length > 0) {
        const newRows: any[] = [];
        section?.matrix_rows?.forEach((row: any) => {
          const masters = row?.master_value_ids || [];
          const subs = row?.sub_master_value_ids || [];
          const rowMapData = row?.rowMapData || {};
          masters.forEach((masterID: number) => {
            const operatorValue = row?.master_operator_map?.[masterID] || null;
            if (subs.length > 0) {
              subs.forEach((subID: number) => {
                const key = `${masterID}_${subID}`;
                let section_matrix_row_id = rowMapData[key] || null;
                if (!section_matrix_row_id) {
                  const uniqueKey = `${sectionIndex}_${row.master_type_id}_${masterID}_${subID}`;
                  section_matrix_row_id = this.originalRowIdMap[uniqueKey] || null;
                }
                newRows.push({
                  section_matrix_row_id: section_matrix_row_id,
                  master_value_id: masterID,
                  sub_master_value_id: subID,
                  operator_value: operatorValue
                });
              });
            }
            else {
              const key = `${masterID}_null`;
              let section_matrix_row_id = rowMapData[key] || null;
              if (!section_matrix_row_id) {
                const uniqueKey = `${sectionIndex}_${row.master_type_id}_${masterID}_null`;
                section_matrix_row_id = this.originalRowIdMap[uniqueKey] || null;
              }
              newRows.push({
                section_matrix_row_id: section_matrix_row_id,
                master_value_id: masterID,
                sub_master_value_id: null,
                operator_value: operatorValue
              });
            }
          });
        });
        section.matrix_rows = newRows;
      }
    });
    if (this.formulasForm.length > 0) {
      payload['formula'] = this.formulasForm.value;
    }
    return payload;
  }

  resetForm() {
    this.selectedForm = null;
    this.formName = '';
    this.isActive = true;
    this.activeTabIndex = 0;
    this.masterTypeSelections = {};
    this.rowMasterSelections = {};
    this.rowSubMasterSelections = {};
    this.rowMapSelections = {};
    this.rowOperatorSelections = {};
    this.originalRowIdMap = {};
    this.originalFieldIdMap = {};
    this.sections.clear();
    this.configForm.patchValue({
      form_id: null,
      form_name: '',
      is_active: true,
      is_delete: false
    });
  }

  private generateKey(label: string): string {
    if (!label) return '';
    return label
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '_')
      .replace(/[^a-z0-9_]/g, '');
  }

  private showSuccess(message: string) {
    if (this.successTimeout) clearTimeout(this.successTimeout);
    this.successMessage = message;
    this.successTimeout = setTimeout(() => {
      this.successMessage = '';
    }, 3000);
  }

  private showError(message: string) {
    if (this.errorTimeout) clearTimeout(this.errorTimeout);
    this.errorMessage = message;
    this.errorTimeout = setTimeout(() => {
      this.errorMessage = '';
    }, 3000);
  }

  onSectionNameChange(value: string, index: any): void {
    const sanitizedValue = value.replace(/\./g, '');
    const sectionGroup = this.sections.at(index) as FormGroup;
    sectionGroup.get('section_name')?.setValue(sanitizedValue);
  }

  openInfoDialog() {
    if (this.sections.length > 0) {
      const data: any = this.sections.value.filter((e: any) => {
        return e?.layout_type === 'Matrix';
      });
      this.formSectionList = data;
    }
    this.tempFormulaData = this.formulasForm.value;
    this.isDialogClosing = false;
    this.showInfoDialog = true;
  }

  closeInfoDialog() {
    this.isDialogClosing = true;
    setTimeout(() => {
      this.showInfoDialog = false;
      this.isDialogClosing = false;
    }, 350); // must match fabDialogClose duration
  }

  selectMasterField(event: any) {
    const selectedValue = event?.value ?? null;
    if (selectedValue == null) {
      this.masterOperatorValue = null;
      this.masterFieldValue = null;
      return;
    }
    if (!Array.isArray(this.masterList)) {
      this.masterOperatorValue = null;
      return;
    }
    const match = this.masterList.find((e: any) => e?.master_value_id === selectedValue);
    this.masterOperatorValue = match?.hasOwnProperty('operator_value') ? match.operator_value : null;
  }

  setOperatorMaster(event: any) {
    if (!Array.isArray(this.masterList) || this.masterFieldValue == null) {
      return;
    }
    const match = this.masterList.find((e: any) => e?.master_value_id === this.masterFieldValue);
    if (match) {
      match['operator_value'] = event?.value ?? null;
    }
  }

  // formula logic
  get sectionFormulas(): FormArray {
    return this.formulasForm;
  }

  createSectionFormula(data?: any): FormGroup {
    return this.fb.group({
      formula_id: [data?.formula_id ?? null],
      formula_title: [data?.formula_title ?? '', Validators.required],
      section_1: [data?.section_1 ?? null, Validators.required],
      operator_1: [data?.operator_1 ?? null, Validators.required],
      section_2: [data?.section_2 ?? null, Validators.required],
      operator_2: [data?.operator_2 ?? null, Validators.required]
    });
  }

  addSectionFormula() {
    this.sectionFormulas.push(this.createSectionFormula());
  }

  closeSectionFormula() {
    this.formulasForm.clear();
    if (this.tempFormulaData.length > 0) {
      this.tempFormulaData.forEach((e: any, index: any) => {
        if (e?.formula_id) {
          this.formulasForm.push(this.createSectionFormula(e));
        }
      })
    }
    this.tempFormulaData = this.sectionFormulas.value.filter((e: any) => e?.formula_id !== null);
    this.showInfoDialog = false;
  }

  saveSectionFormula() {
    this.showInfoDialog = false;
  }

  removeSectionFormula(index: number) {
    this.sectionFormulas.removeAt(index);
  }

  trackByFormula(index: number, formula: any): any {
    const formulaId = formula.get('formula_id')?.value;
    return formulaId !== null ? formulaId : index;
  }

  ngOnDestroy() {
    this.resetForm();
    if (this.successTimeout) clearTimeout(this.successTimeout);
    if (this.errorTimeout) clearTimeout(this.errorTimeout);
  }
}